import "./App.css";
import "./Responsive.css";
import { BrowserRouter as Router } from "react-router-dom";
import RoutesComponent from "./RoutesComponent";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ProfileProvider } from "./context/ProfileContext";
function App() {
  return (
    <Router>
      <ProfileProvider>
        <RoutesComponent />
        <ToastContainer />
      </ProfileProvider>
    </Router>
  );
}

export default App;
